import React from 'react'
import { Result } from 'antd';
import { UserOutlined } from "@ant-design/icons"
import { Typography } from 'antd';
import styled from 'styled-components';


const { Title, Paragraph } = Typography

export default function LoginOption({ props: { title, description, extra } }) {
	return (
		<Wrapper>
			<Result
				title={<Title level={2}>{title}</Title>}
				subTitle={<Paragraph>{description}</Paragraph>}
				icon={<UserOutlined style={{ color: "white" }} />}
			/>
			{extra}
		</Wrapper>
	)
}


const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`